export const OrderInfo = () => {
  return <div>This is order info page.</div>;
};
